import muiTableCell from "@material-ui/core/TableCell";
import { withStyles } from "@material-ui/core";

const styles = theme => ({
    head: {
        backgroundColor: "#333333",
        [theme.breakpoints.up("lg")]: {
            padding: "0px 16px",
            "&:last-child": {
                paddingRight: 16
            }
        },
        [theme.breakpoints.down("md")]: {
            padding: "0px 8px",
            "&:last-child": {
                paddingRight: 8
            }
        },
        "& p": {
            fontWeight: 500,
            color: "#ffffff"
        },
        "& svg": {
            color: "#ffffff"
        }
    },
    body: {
        fontSize: 14,
        fontFamily: "'Source Sans Pro', sans-serif",
        color: "#666666",
        fontWeight: 400,
        [theme.breakpoints.up("lg")]: {
            padding: "0px 16px",
            "&:last-child": {
                paddingRight: 16
            }
        },
        [theme.breakpoints.down("md")]: {
            padding: "0px 8px",
            "&:last-child": {
                paddingRight: 8
            }
        }
    }
});

export default withStyles(styles)(muiTableCell);
